<template>
  <div class="ma-3">
    <form>
      <h1 class="title font-weight-regular">
        Testy {{ form.type }} - {{ form.prisoner_full.string_details }}
      </h1>
      <v-row>
        <v-col cols="5">
          <v-row>
            <v-icon
              v-if="form.pravne_aspekty"
              color="success"
              x-large
            >
              mdi-check
            </v-icon>
            <v-icon
              v-else
              color="error"
              x-large
            >
              mdi-close
            </v-icon>
            <v-file-input
              v-model="pravne_aspekty_file"
              accept=".pdf"
              label="Právne aspekty"
            />
          </v-row>

          <v-btn
            v-if="form.pravne_aspekty"
            color="primary"
            @click="downloadItem(form.pravne_aspekty, 'pravne_aspekty')"
          >
            Stiahnuť
          </v-btn>
        </v-col>
        <v-spacer />
        <v-col cols="5">
          <v-row>
            <v-icon
              v-if="form.financna_gramotnost"
              color="success"
              x-large
            >
              mdi-check
            </v-icon>
            <v-icon
              v-else
              color="error"
              x-large
            >
              mdi-close
            </v-icon>

            <v-file-input
              v-model="financna_gramotnost_file"
              accept=".pdf"
              label="Finančná gramotnosť"
            />
          </v-row>

          <v-btn
            v-if="form.financna_gramotnost"
            color="primary"
            @click="
              downloadItem(form.financna_gramotnost, 'financna_gramotnost')
            "
          >
            Stiahnuť
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="5">
          <v-row>
            <v-icon
              v-if="form.zavislosti"
              color="success"
              x-large
            >
              mdi-check
            </v-icon>
            <v-icon
              v-else
              color="error"
              x-large
            >
              mdi-close
            </v-icon>

            <v-file-input
              v-model="zavislosti_file"
              accept=".pdf"
              label="Závislosti"
            />
          </v-row>
          <v-btn
            v-if="form.zavislosti"
            color="primary"
            @click="downloadItem(form.zavislosti, 'zavislosti')"
          >
            Stiahnuť
          </v-btn>
        </v-col>
        <v-spacer />

        <v-col cols="5">
          <v-row>
            <v-icon
              v-if="form.zamestnanost"
              color="success"
              x-large
            >
              mdi-check
            </v-icon>
            <v-icon
              v-else
              color="error"
              x-large
            >
              mdi-close
            </v-icon>

            <v-file-input
              v-model="zamestnanost_file"
              accept=".pdf"
              label="Zamestnanosť"
            />
          </v-row>
          <v-btn
            v-if="form.zamestnanost"
            color="primary"
            @click="downloadItem(form.zamestnanost, 'zamestnanost')"
          >
            Stiahnuť
          </v-btn>
        </v-col>
      </v-row>

      <v-layout
        v-if="!form.closed"
        pt-5
      >
        <div
          v-if="uploading"
          class="text-center"
        >
          <v-progress-circular
            indeterminate
            color="primary"
          />
        </div>
        <v-btn
          v-else
          dark
          color="primary"
          @click="updateItem()"
        >
          Uložiť
        </v-btn>

        <div class="flex-grow-1" />
        <v-btn
          v-if="!uploading"
          dark
          color="error"
          @click="closeItem()"
        >
          Uzatvoriť
        </v-btn>
      </v-layout>
    </form>

    <v-snackbar
      v-model="snackbar_saved"
      color="success"
      :timeout="3000"
    >
      Uložené
      <v-btn
        text
        @click="snackbar_saved = false"
      >
        Zavrieť
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="snackbar_error"
      color="error"
      :timeout="5000"
    >
      Chyba
    </v-snackbar>
  </div>
</template>

<script>
import Vue from "vue";
import { APIService } from "@/http/APIService.js";
import VeeValidate, { Validator } from "vee-validate";
import sk from "vee-validate/dist/locale/sk";
import axios from "axios";

Vue.use(VeeValidate);
Validator.localize("sk", sk);

const apiService = new APIService();

export default {
  $_veeValidate: {
    validator: "new",
  },

  components: {},

  data: () => ({
    snackbar_saved: false,
    snackbar_error: false,
    dialog: false,
    dialog_item: {
      nazov: "",
      texty: [],
    },
    uploading: false,
    pravne_aspekty_file: null,
    financna_gramotnost_file: null,
    zavislosti_file: null,
    zamestnanost_file: null,

    form: {
      id: null,
      type: "",
      pravne_aspekty: null,
      financna_gramotnost: null,
      zavislosti: null,
      zamestnanost: null,
      prisoner_full: {
        string_details: "",
      },
    },
  }),

  computed: {},

  created() {
    this.getItem();
  },

  methods: {
    showDialog(x) {
      this.dialog = true;
      this.dialog_item.nazov = this.dialogs[x].nazov;
      this.dialog_item.texty = this.dialogs[x].texts;
    },
    getItem() {
      apiService.getGeneralTesty(this.$route.params.id).then((response) => {
        this.form = response;
      });
    },

    updateItem() {
      this.uploading = true;

      let formData = new FormData();

      for (var key in this.form) {
        if (
          key == "pravne_aspekty" ||
          key == "financna_gramotnost" ||
          key == "zavislosti" ||
          key == "zamestnanost"
        )
          continue;

        if (this.form[key] != null) formData.set(key, this.form[key]);
      }

      if (this.form.pravne_aspekty == null)
        formData.append("pravne_aspekty", "");

      if (this.form.financna_gramotnost == null)
        formData.append("financna_gramotnost", "");

      if (this.form.zavislosti == null) formData.append("zavislosti", "");

      if (this.form.zamestnanost == null) formData.append("zamestnanost", "");

      if (this.pravne_aspekty_file instanceof File)
        formData.append("pravne_aspekty", this.pravne_aspekty_file);

      if (this.financna_gramotnost_file instanceof File)
        formData.append(
          "financna_gramotnost",
          this.financna_gramotnost_file
        );

      if (this.zavislosti_file instanceof File)
        formData.append("zavislosti", this.zavislosti_file);

      if (this.zamestnanost_file instanceof File)
        formData.append("zamestnanost", this.zamestnanost_file);

      apiService.updateGeneralTesty(formData, this.$route.params.id).then(
        (response) => {
          this.uploading = false;
          this.snackbar_saved = true;
          this.form = response;
        },
        () => {
          this.uploading = false;
          this.snackbar_error = true;
        }
      );
    },
    closeItem() {
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          if (
            confirm(
              "Naozaj chcete uložiť a uzatvoriť tento formulár? (Následne nebude možné už formulár upravovať)"
            )
          ) {
            this.form.closed = true;
            this.updateItem();
          }
        } else {
          alert("Všetky položky musia byť vyplnené.");
        }
      });
    },

    downloadItem(url, typeItem) {
      var oldThis = this;
      axios
        .get(url, { responseType: "blob" })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            oldThis.form.prisoner_full.string_details + "_" + typeItem + ".pdf"
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch(function () {
          oldThis.snackbar_error = true;
        });
    },
  },
};
</script>